/* eslint-disable */
import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useQuery } from "@apollo/react-hooks";
import gql from "graphql-tag";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

import Profiles from "./Profiles.jsx";

const GOLDEN_RATIO = (1 + Math.sqrt(5)) / 2;
const RECIPROCAL_GR = 1 / GOLDEN_RATIO;
const DURATION = RECIPROCAL_GR;

const GET_DATA = gql`
  {
    themeSettings {
      global {
        portfolioColumns {
          items {
            ... on Profile {
              id
              title
              slug
              featuredImage {
                node {
                  sourceUrl
                }
              }
              content
              portfolio {
                founder
                website {
                  title
                  target
                  url
                }
                additionalLinks {
                  additionalLink {
                    title
                    target
                    url
                  }
                }
              }
              portfolioCategories {
                nodes {
                  name
                }
              }
            }
          }
        }
        portfolioSubheading
        portfolioImage {
          sourceUrl
        }
      }
    }
  }
`;

function Index() {
  const location = useLocation();
  const history = useHistory();
  const queryParams = new URLSearchParams(location.search);
  const category = queryParams.get("cat");
  
  const { loading, error, data } = useQuery(GET_DATA);
  const [items, setItems] = useState([]);
  const [filteredCat, setFilteredCat] = useState(category || "Spotlight" ||"Filter");

  useEffect(() => {
    if (!data) return;
    if(category || filteredCat){
      const cats = document.querySelectorAll('.cat');
      const catSelect = document.querySelector('.filter-select select');
      cats.forEach((cat) => {
        if(cat.innerHTML === category || cat.innerHTML === filteredCat){
          cat.classList.add('active');
          catSelect.value = cat.innerHTML;
        }else if(filteredCat === "Filter" && cat.innerHTML === "All Categories"){
          cat.classList.add('active');
        }else{
          cat.classList.remove('active');
        }
      })
    }
    const container = document.querySelector(".main-scrolling-container");
    const main = document.querySelector("main");
    const mainInner = document.querySelector(".pageTransition__slide");
    const titles = document.querySelectorAll(".a__title");
    const titlesSibling =
      titles[0] && titles[0].parentElement.nextElementSibling;

    setItems(data.themeSettings.global.portfolioColumns[0].items);

    const tl = gsap.timeline({
      defaults: { duration: DURATION, ease: "sine.out" },
    });

    tl.set([titles, titlesSibling], { autoAlpha: 0, translateY: 20 });

    tl.to([main, mainInner], {
      autoAlpha: 1,
      ease: "sine.out",
    });

    tl.to([titles, titlesSibling], {
      translateY: 0,
      autoAlpha: 1,
      ease: "sine.out",
      stagger: 0.2,
      onComplete: function () {
        ScrollTrigger.refresh();
      },
    });

    gsap.to(titles, {
      scrollTrigger: {
        trigger: titles,
        start: "top 10%",
        end: "300%",
        scrub: true,
        scroller: container,
      },
      y: (i, target) =>
        -ScrollTrigger.maxScroll(window) * (target.dataset.speed * 0.075),
      ease: "none",
    });
  }, [data, category, filteredCat]);

  if (loading) return <div className="h-screen w-screen"></div>;

  if (error)
    return <React.Fragment>{`Error! ${error.message}`}</React.Fragment>;

  const accordion = document.querySelectorAll(".accordion");

  function handleClick(e) {
    const cats = document.querySelectorAll(".cat");
    cats.forEach((cat) => {
      cat.classList.remove("active");
      if(cat.innerHTML === filteredCat){
        cat.classList.add("active");
      }
    });
  }

  function handleCatClick(e) {
    e.preventDefault();
    if(e.target.innerHTML === 'All Categories') {
      resetCategory();
    }else{
      setFilteredCat(e.target.innerHTML);
      handleClick(e);
    }
  }
  function handleCatChange(e) {
    e.preventDefault();
    if(e.target.value === 'All Categories') {
      resetCategory();
    }else{
      setFilteredCat(e.target.value);
    }
    handleClick(e);
  }

  function resetCategory() {
    setFilteredCat("Filter");
    if (category) {
      queryParams.delete("cat");
      history.push({search: queryParams.toString()});
    }
  }

  // get categories
  let cats = [];

  data.themeSettings.global.portfolioColumns.map((column) =>
    column.items.map((item) =>
      item.portfolioCategories.nodes.map((cat) => {
        if(cat.name.toLowerCase() !== 'spotlight')
        cats.push(cat.name)
      })
    )
  );

  let catsUnique = Array.from(new Set(cats.sort()));

  return (
    <div className="pageTransition__slide">
      {data.themeSettings.global.portfolioSubheading ? (
        <div className="container">
          <h2
            className="mb-10 lg:mb-20 leading-brand-tight text-brand-11vw lg:text-brand-7xl a__title"
            data-speed=".25"
          >
            {data.themeSettings.global.portfolioSubheading}
          </h2>
        </div>
      ) : null}

      {/* accordion test block  */}
      <div className="filter-select flex flex-wrap items-center lg:pl-brand-12 p-brand-4 py-3 lg:hidden">
        <label htmlFor="category" className="uppercase basis-full">Filter By</label>
        <div className="filter-container basis-full">
          <select name="category" onChange={handleCatChange} className="border border-brand-blood-orange py-1 px-5 uppercase text-brand-maroon w-full">
            <option value="All Categories">All Categories</option>
            {catsUnique.map(function (cat, i) {
              return (
                <option key={`${i}-portfolio-cat`} value={cat}>{cat}</option>
              );
            })}
          </select>
        </div>
      </div>

      <div className=" lg:pt-4 lg:block hidden">
        <div className="lg:pl-brand-12 p-brand-4 accordion flex flex-wrap items-center py-3 gap-4">
          <span className="uppercase basis-full">
            Filter By
          </span>
          <ul className="flex flex-wrap cat-list">
            <li>
              <a
                href="#"
                onClick={handleCatClick}
                className="mr-3 text-brand-s mb-5 border rounded-full py-1 px-3 cat uppercase text-brand-maroon active default"
              >
                All Categories
              </a>
            </li>
            {catsUnique.map(function (cat, i) {
              return (
                <li key={`${i}-portfolio-cat`}>
                  <a
                    href="#"
                    onClick={handleCatClick}
                    className="mr-3 text-brand-s mb-5 border rounded-full py-1 px-3 cat uppercase text-brand-maroon"
                  >
                    {cat}
                  </a>
                </li>
              );
            })}
          </ul>
          </div>
        {/* </div> */}
      </div>
      {/* accordion test block  */}
      <div className="flex bg-white">
        <div className="w-full relative">
          <div className="flex justify-between">
            <ul className="grid lg:grid-cols-3  md:grid-cols-3 grid-cols-2 w-full">
              {items.map((item) => (
                <Profiles
                  key={`${item.id}-profiles`}
                  category={filteredCat}
                  item={item}
                  onClick={handleCatClick}
                />
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Index;



// WEBPACK FOOTER //
// ./scripts/components/Portfolio/Index.jsx